const eventCreatedParam = 'created';

export default eventCreatedParam;
